<template>
  <v-card flat class="pa-4">
    <v-switch v-model="preferences.bottleDuration" label="Track duration" dense/>
    <v-switch v-model="preferences.bottleIncomplete" label="Allow incomplete bottling" dense/>
    <v-switch v-model="preferences.lotFromSpirit" label="Take lot code from spirit" dense/>
    <v-tooltip bottom  max-width="300" nudge-top="20" open-delay="1000">
      <template v-slot:activator="{on}">
        <v-switch v-model="preferences.bottleProof" dense>
          <span slot="label" v-on="on">Only bottle from proofed tanks</span>
        </v-switch>
      </template>
      When selected, only tanks that have been proofed to the same strength as
      the product can be selected to bottle from.
      It is recommended that this option be used to add an additional check to make sure bottling strength is correct.
    </v-tooltip>



    <v-tooltip bottom max-width="300" open-delay="1000" nudge-top="20">
      <template v-slot:activator="{on}">
        <v-container v-on="on" class="pb-0">
          <v-row>
            <v-col cols="8">
              <decimal-number-input label="+/- bottling tolerance" v-model="preferences.bottleTolerance" prefix="" suffix="% alc./vol." :precision="1" :max="9.9"/>
            </v-col>
          </v-row>
        </v-container>
      </template>
      The allowed tolerance on strength of product when bottling.
    </v-tooltip>

    <template>
      <v-container class="pb-0">
        <v-row>
          <v-col>
            <decimal-number-input label="Loss tolerance" v-model="preferences.percentLoss" prefix="" suffix="%" :precision="1" :max="100"/>
          </v-col>
          <v-col>
            <decimal-number-input label="Loss tolerance" v-model="preferences.laaLoss" prefix="" suffix="LAA" :precision="3"/>
        </v-col>
        </v-row>
      </v-container>
    </template>

    <v-tooltip bottom  max-width="300" nudge-top="20" open-delay="1000">
      <template v-slot:activator="{on}">
        <v-switch v-model="preferences.bottleDutyPaidOption" dense @change="preferences.bottleDutyPaid = false" class="mt-n2">
          <span slot="label" v-on="on">Show option to put in duty-paid</span>
        </v-switch>
      </template>
      Whether the option to place bottled product immediately into duty-paid inventory (vs. in-bond) is available.
    </v-tooltip>
    <v-tooltip bottom  max-width="300" nudge-top="20" open-delay="1000">
      <template v-slot:activator="{on}">
        <v-switch v-model="preferences.bottleDutyPaid" dense :disabled="preferences.bottleDutyPaidOption">
          <span slot="label" v-on="on">Make all bottlings duty-paid</span>
        </v-switch>
      </template>
      If selected, bottled product will be placed into duty-paid inventory, incurring excise immediately.
    </v-tooltip>

    <v-row dense class="mt-4">
      <v-col cols="3 pt-3">Numbering</v-col>
      <v-col cols="3">
        <v-text-field label="Prefix" v-model="preferences.numberPrefix" :rules="[fieldRules.maxLength(10)]" outlined dense :counter="10"/>
      </v-col>
      <v-col cols="3">
        <v-text-field label="Suffix" v-model="preferences.numberSuffix" :rules="[fieldRules.maxLength(10)]" outlined dense :counter="10"/>
      </v-col>
      <v-col cols="3">
        <decimal-number-input label="Start at" v-model="preferences.numberStart" :precision="0" integer prefix=""/>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: 'ProductionBottlingPreferences',
  data() {
    return {
      preferences: {}
    }
  },
  watch: {
    preferences: {
      async handler() {
        const results = await this.$apiCall(`mutation ProductionBottlingPreferences($input:BottlingPreferencesInput!) {
                                              bottlingSetPreferences(input:$input) {
                                                bottleDuration,bottleIncomplete,bottleProof,bottleTolerance,
                                                bottleDutyPaidOption,bottleDutyPaid,lotFromSpirit,
                                                percentLoss,laaLoss
                                                numberPrefix, numberSuffix, numberStart
                                              }
                                            }`,
                                            {input:this.preferences});
        if (!results.error)
          this.$emit('update', results.data.bottlingSetPreferences)
      },
      immediate: false,
      deep: true
    }
  },
  async created() {
    const results = await this.$apiCall(`query ProductionBottlingPreferences {
                                          bottlingPreferences {
                                            bottleDuration,bottleIncomplete,bottleProof,bottleTolerance,
                                            bottleDutyPaidOption,bottleDutyPaid,lotFromSpirit,
                                            percentLoss,laaLoss
                                            numberPrefix, numberSuffix, numberStart
                                          }
                                        }`,
                                        {});
    if (!results.error)
      this.preferences = results.data.bottlingPreferences;
  }
}
</script>